import { render, staticRenderFns } from "./UpdatePersonalLoanStatusModal.vue?vue&type=template&id=8d27ef52"
import script from "./UpdatePersonalLoanStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalLoanStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports